import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Notifications from '@kyvg/vue3-notification'
// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import './registerServiceWorker'
import {LoadingPlugin} from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import VueClipboard from 'vue3-clipboard'
//import vue3GoogleLogin from 'vue3-google-login'
//import VueGtag from "vue-gtag";
import 'shepherd.js/dist/css/shepherd.css'

const myCustomLightTheme = {
  dark: false,
  colors: {
    background: '#2a2f34',
    surface: '#2a2f34',
    primary: '#6200EE',
    'primary-darken-1': '#6200EE',
    secondary: '#6200EE',
    'secondary-darken-1': '#018786',
    error: '#6200EE',
    info: '#6200EE',
    success: '#6200EE',
    warning: '#6200EE',
  }
}
const vuetify = createVuetify({
  theme: {
    defaultTheme: 'myCustomLightTheme',
    themes: {
      myCustomLightTheme,
    }},
  components,
  directives,
})

var app = createApp(App);
app.config.globalProperties.userInfo = {};
app.config.globalProperties.openMemoryManagement = function() {
  // Dispatch custom event to open memory modal
  window.dispatchEvent(new CustomEvent('openMemoryManagement'));
};
app.use(router).use(Notifications).use(VueClipboard, {
  autoSetContainer: true,
  appendToBody: true,
}).use(vuetify).use(LoadingPlugin)
//.use(vue3GoogleLogin, {clientId: '779203755962-erff37vc37ktch6j3bblbast9r9akgha.apps.googleusercontent.com'}).use(VueGtag, {config: { id: "G-3927S8441L" }}) GhatiChanges
  .mount('#app')

